import React, { useState, useRef, useEffect } from "react"
import { useParams, withRouter } from "react-router-dom"
import { useSelector, connect, useDispatch } from "react-redux"
import {
  Row,
  Col,
  Input,
  Label,
  Button,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import PropTypes from "prop-types"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"
import { isEmpty } from "lodash"
import Modal from "react-bootstrap/Modal"
import * as ecFollowupAction from "../../store/b3BlcmF0aW9uc0/actions"
import { ToastContainer, toast } from "react-toastify"
import moment from "moment"

const OperationsReviews = () => {
  let { id } = useParams()
 const dispatch = useDispatch()
  useEffect(() => {
      dispatch(ecFollowupAction.loadReview(id))
      
    }, [])
 //date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
      responseLogin.setting &&
      responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    const ecUpdate = useSelector((state) => state.operationsFollowUp)
    
      const {
      review_List=[],

      } = ecUpdate
  // 
  const [addReview, setAddReview] = useState(false)
  //multi screenshot image upload
  const [operationAttachment, setOperationAttachment] = useState([])

  const operationAttachmentChange = async (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files)
      setOperationAttachment(files) // Set selected files first

      let uploadedFiles = [...operationAttachment] // Copy existing state

      for (let file of files) {
        const formData = new FormData()
        formData.append("file", file)

        try {
          const res = await api.post("/image_upload", formData)
          if (res?.data?.data) {
            uploadedFiles.push(res.data.data) // Add uploaded file URL or data
          }
        } catch (error) {
          console.error("Upload failed", error)
        }
      }

      setOperationAttachment(uploadedFiles) // Update state after all uploads
    }
  }
  
  const [reviewRating, setReviewRating] = useState([])
  const [reviewData, setReviewData] = useState({
    reviewReason: "",
    _id: ""
  })
  const handleReview = async (e) => {
    setReviewData({ ...reviewData, [e.target.name]: e.target.value })
  }
  //inprogress checkbox
  const [negativeReason, setNegativeReason] = useState("")

  const statusListEngage = [
    {
      label: "Negative Review Removed",
      value: true,
    },
  ]

  const handleStatusEngageChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setNegativeReason(value)
    } else {
      setNegativeReason(false)
    }
  }
  const [isEdit, setIsEdit] = useState(false)
  const editReview = (data) => {
    setIsEdit(true)
    setAddReview(true)
    setReviewData({
      reviewReason: data.noReviewReason,
      _id: data._id
    })
    setNegativeReason(data.negativeReviewRemoved)
    setReviewRating({ label: data.ratings, value: data.ratings })
    setOperationAttachment(data.images)
  }
  // attachments details
  const [openImagePreview, setOpenImagePreview] = useState(false)
  const [imageDetails, setImageDetails] = useState([])
  // data table
  const reviewTable =
    !isEmpty(review_List) && review_List.length > 0 ?
      review_List.map((data, index) => {


        return {
          sNo: index + 1,
          action: (
            <Button
              type="submit"
              style={{
                fontSize:
                  "8px",
              }}
              onClick={() => { editReview(data) }}
              className={
                "btn btn-success buttons"
              }
            >
              <i className="fas fa-edit icon-btn"></i>
            </Button>
          ),
          reviewRating: data.ratings || "--",
          noReviewReason: data.noReviewReason || "--",
          negativeReviewReason: data.negativeReviewRemoved == true ? "YES" : data.negativeReviewRemoved == false ?
            "NO" : "--",
          review: data.images || [],
          leadId: data.leadId,
          _id: data._id,
          reviewDateAndTime:data.createdOn?moment(data.createdOn).format(`${dateFormate} hh:mm A`)
          :data.createdAt?moment(data.createdAt).format(`${dateFormate} hh:mm A`):"--",
          updatedDate:data.updatedOn?moment(data.updatedOn).format(`${dateFormate} hh:mm A`):
          data.updatedAt?moment(data.updatedAt).format(`${dateFormate} hh:mm A`):
          "--"
        }
      }) : []
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "reviewRating",
      text: "Review Rating",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "noReviewReason",
      text: "No Review Reason",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "negativeReviewReason",
      text: "Negative Review Reason",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "review",
      text: "Review",
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
      formatter: (cellContent, row) => {

        const attachmentDetails = row && row.review
        const attachCount =
          !isEmpty(attachmentDetails) && attachmentDetails.length > 0
            ? attachmentDetails.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(attachmentDetails) ? (
                  <a
                    onClick={() => {
                      setOpenImagePreview(true)
                      setImageDetails(attachmentDetails)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
    },
    {
      dataField: "reviewDateAndTime",
      text: "Review Date & Time",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "updatedDate",
      text: "Updated Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

  ]
  // pagination options
  const options = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  const addReviewDetais = () => {
    setIsEdit(false)
    setAddReview(true)
    setReviewRating([])
    setReviewData({
      reviewReason: "",
      _id: ""
    })
    setNegativeReason("")
    setOperationAttachment([])
  }
  //React Validations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const addReviewApi = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const payload = {
        "leadId": id,
        "images": operationAttachment,
        "ratings": reviewRating.value,
        "noReviewReason": reviewData.reviewReason,
   
      }
      if (negativeReason === true) {
        payload.negativeReviewRemoved = negativeReason
      }
      dispatch(ecFollowupAction.addReview(payload))
      setAddReview(false)
      setTimeout(() => {
        dispatch(ecFollowupAction.loadReview(id))
          toast.success("Review Added successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
        }, 500)
      console.log(payload)
    } else {
      simpleValidator.current.showMessages()
      setAddReview(true)
      forceUpdate(1)

    }
  }
  const updateReviewApi = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const payload = {
        _id: reviewData._id,
        "leadId": id,
        "images": operationAttachment,
        "ratings": reviewRating.value,
        "noReviewReason": reviewData.reviewReason,
   
      }

      if (negativeReason === true) {
        payload.negativeReviewRemoved = negativeReason
      }
      setAddReview(false)
      dispatch(ecFollowupAction.updateReview(payload))
      setTimeout(() => {
        dispatch(ecFollowupAction.loadReview(id))
          toast.success("Review Updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
        }, 500)
      console.log(payload)
    } else {
      simpleValidator.current.showMessages()
      setAddReview(true)
      forceUpdate(1)

    }
  }
  return (
    <React.Fragment>
      <div className="text-align-center mt-4 mb-4">

        <Row className="quote-head-content">
          <Col lg="9"
            md="9"
            sm="6"
            xs="6"
            className="d-flex flex-row"
          >
            <p className="quote-head">
              Review
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="xy123"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip
                  placement="right"
                  target="xy123"
                >
                  Review
                </UncontrolledTooltip>
              </span>
            </p>
            <>

              <button
                style={{
                  color: "#34C28F",
                  border: "1.8px solid #34C28F",
                  borderRadius: "4px",
                  padding: "4px 10px",
                  height: "30px",
                  width: "max-content",
                  textAlign: "center",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => addReviewDetais()}
              >
                <i className="fas fa-plus"></i> Add Review
              </button>
            </>
          </Col>
        </Row>
        <Col md="12" lg="12" xl="12" className="mt-3">
          <PaginationProvider
            pagination={paginationFactory(options)}
            keyField="_id"
            columns={columns}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="_id"
                data={reviewTable}
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div>
                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                      <Row className="d-flex flex-row  ">

                        <Col>
                          <BootstrapTable
                            {...props.baseProps}
                            responsive
                            striped={true}
                            bordered={true}
                            keyField="_id"
                            columns={columns}
                            noDataIndication={"No Data Found..."}
                            {...paginationTableProps}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            <SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              <PaginationTotalStandalone
                                {...paginationProps}
                              />
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone
                              {...paginationProps}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </Col>
        {addReview && (
          <>
            <Row
              style={{ margin: "10px 0px" }}
              className="d-flex flex-row ec-followup-form-content"
            >

              <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>
                    {"Review Screenshots"}
                  </Label>
                </div>
                <div className="d-flex flex-row align-items-center">
                  <Button className=" btn btn-warning  position-relative fs-5">
                    <i className="fas fa-laptop"></i>
                    <Input
                      type="file"
                      name="operationAttachment"
                      accept="application/pdf, audio/mp3 , image/jpeg"
                      multiple
                      onChange={(e) => operationAttachmentChange(e)}
                      style={{
                        position: "absolute",
                        fontSize: "50px",
                        opacity: 0,
                        right: 0,
                        top: 0,
                      }}
                    />
                    <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                      {operationAttachment.length > 0 ? operationAttachment.length : 0}
                    </span>
                  </Button>
                </div>
                <div className="text-decoration-underline text-danger text-start">
                  {operationAttachment.length > 0 &&
                    operationAttachment.map((file, index) => (
                      <a
                        key={index}
                        href={typeof file === "string" ? file : URL.createObjectURL(file)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-block"
                        style={{ fontSize: "14px", textAlign: "left" }} // Ensures left alignment
                      >
                        {`Image ${index + 1}`}
                      </a>
                    ))}
                </div>
                <div
                  style={{ textTransform: "capitalize" }}
                >
                  {simpleValidator.current.message(
                    "ReviewScreenshot",
                    operationAttachment,
                    "required"
                  )}
                </div>

              </Col>
              <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                <div className="d-flex justify-content-between">
                  <Label
                    className="form-label"
                    htmlFor={"Follow-Up-Date"}
                  >
                    {"Review Rating"}<span className="required">*</span>
                  </Label>
                </div>

                <Select
                  type="text"
                  name="reviewRating"
                  value={reviewRating}
                  onChange={(e) => setReviewRating(e)}
                  options={[{ label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" },
                  { label: "4", value: "4" }, { label: "5", value: "5" }, { label: "No Review", value: "No Review" }
                  ]}
                  placeholder="Select Review Ratings"
                  classNamePrefix="select2-selection"
                />
                <div
                  style={{ textTransform: "capitalize" }}
                >
                  {simpleValidator.current.message(
                    "ReviewRating",
                    reviewRating,
                    "required"
                  )}
                </div>
              </Col>
              {reviewRating.value === "No Review" && (
                <>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label
                        className="form-label"
                        htmlFor={"Follow-Up-Date"}
                      >
                        {"No Review Reason"}
                      </Label>
                    </div>
                    <Input
                      type="textarea"
                      name="reviewReason"
                      value={reviewData.reviewReason}
                      onChange={(e) => handleReview(e)}
                      placeholder="Enter Reason"
                    />
                  </Col>
                </>
              )}
            {isEdit 
           // && (reviewRating.value === "1" || reviewRating.value === "2" || reviewRating.value === "3")
             && (

                <Col lg="3" md="3" sm="12" xs="12" className="mt-5">

                  <div className="d-flex flex-row">
                    {statusListEngage.map((status, index) => {
                      return (
                        <div className="d-flex flex-row" key={index}>
                          <Input
                            type="checkbox"
                            name="negativeReason"
                            value={status.value}
                            checked={negativeReason === status.value}
                            onChange={(e) =>
                              handleStatusEngageChange(e, status.value)
                            }
                            className="font-size-15"
                          />
                          <Label
                            className="mx-2"
                            style={{ marginTop: "2px", fontSize: "12px" }}
                          >
                            {status.label}
                          </Label>
                        </div>
                      )
                    })}
                  </div></Col>
              )}
              <Col md="12" xl="12" lg="12" className="mt-5 mb-3">
                <div
                  style={{ float: "right" }}
                  className="d-flex flex-row"
                >
                  <Button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      setAddReview(false)
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success mx-2"
                    onClick={(e) => {
                      if (isEdit) {
                        updateReviewApi(e)
                      } else {
                        addReviewApi(e)
                      }

                    }}
                  >
                    {isEdit ? "Update" : 'Submit'}
                  </Button>

                </div>
              </Col>


            </Row>
          </>
        )}
        {openImagePreview && (
          <Modal
            show={openImagePreview}
            size="lg"
            backdrop="static"
          >
            <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
              <h5 style={{ color: "white" }}>
                 Screenshots
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg="12" md="12" sm="12" xs="12">
                  <Table bordered striped responsive>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Screenshots</th>
                      </tr>
                    </thead>
                    <tbody>
                      {imageDetails &&
                        imageDetails.length > 0 ? (
                        imageDetails.map((data, index) => {
                          const attachmentValue = data && data
                          const splitAttach = !isEmpty(
                           attachmentValue
                          )
                            ?attachmentValue.split(".")
                            : ""
                          const attachExtension = !isEmpty(
                            splitAttach
                          )
                            ? splitAttach.pop()
                            : ""

                          return (
                            <>
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  {" "}
                                  {(attachmentValue &&
                                    attachExtension === "jpeg") ||
                                    (attachmentValue &&
                                      attachExtension === "jpg") ||
                                    (attachmentValue &&
                                      attachExtension === "png") ? (
                                    <a
                                      onClick={() =>
                                        window.open(
                                          attachmentValue,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                          color: "#E40D8C",
                                        }}
                                      >
                                        View
                                      </span>
                                    </a>
                                  ) : (attachmentValue &&
                                    attachExtension === "mp3") ||
                                    (attachmentValue &&
                                      attachExtension === "m4a") ||
                                    (attachmentValue &&
                                      attachExtension === "mp4") ? (
                                    <a href={attachmentValue}>
                                      <audio controls>
                                        <source
                                          src={attachmentValue}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support
                                        the audio element.
                                      </audio>
                                    </a>
                                  ) : (
                                    "--"
                                  )}
                                </td>

                              </tr>
                            </>
                          )
                        })
                      ) : (
                        <tr key={0}>
                          <td
                            colSpan={2}
                            className="text-align-center"
                          >
                            {"No Data Found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={() => setOpenImagePreview(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
  <ToastContainer
                    position="top-right"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
      </div>
    </React.Fragment>
  )
}
OperationsReviews.propTypes = {
  dispatch: PropTypes.func,
  record_quotation_details: PropTypes.array,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to prop
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsReviews)
)


